import React, { useState } from "react";

import { Ds } from "@accurx/design";
import { AutoFocusHeading } from "@accurx/navigation";

import {
    StyledMain,
    StyledPageWrapper,
} from "app/workspace/pages/shared/Layout/Layout.styles";

import { StyledForm } from "../MapWorkspacePage.styles";
import { UserTypedOrganisation } from "../MapWorkspacePage.types";
import { MapWorkspaceCollapsibleInfo } from "./MapWorkspaceCollapsibleInfo";

export const MapWorkspaceAddOrg = ({
    onAddOrganisation,
    currentWorkspaceName,
    onBackClick,
}: {
    currentWorkspaceName: string;
    onAddOrganisation: ({
        organisationName,
        organisationPostcode,
        organisationOdsCode,
    }: UserTypedOrganisation) => void;
    onBackClick: () => void;
}) => {
    const [organisationPostcode, setOrganisationPostcode] = useState("");
    const [organisationName, setOrganisationName] = useState("");
    const [organisationOdsCode, setOrganisationOdsCode] = useState("");

    const [error, setError] = useState(false);

    const onButtonClick = (e: React.FormEvent) => {
        e.preventDefault();
        setError(false);

        if (!organisationName || !organisationPostcode) {
            setError(true);
            return;
        }

        onAddOrganisation({
            organisationName,
            organisationPostcode,
            organisationOdsCode,
        });
    };

    return (
        <StyledPageWrapper flexDirection="column">
            <StyledMain gap="3" flexDirection="column">
                <AutoFocusHeading size="xlarge" as="h1">
                    Submit an organisation to link to {currentWorkspaceName}
                </AutoFocusHeading>

                <MapWorkspaceCollapsibleInfo
                    workspaceName={currentWorkspaceName}
                />

                <StyledForm onSubmit={onButtonClick}>
                    <Ds.Flex
                        gap="3"
                        flexDirection="column"
                        style={{ width: "100%" }}
                    >
                        <Ds.Form.Field name="organisation-name">
                            <Ds.Form.Label>Organisation name</Ds.Form.Label>
                            <Ds.Form.Description>
                                For example 'Example NHS Foundation Trust'
                            </Ds.Form.Description>
                            <Ds.Form.Control>
                                <Ds.TextInput
                                    id="organisation-name"
                                    value={organisationName}
                                    type="text"
                                    onChange={(e): void => {
                                        setError(false);
                                        setOrganisationName(e.target.value);
                                    }}
                                    isInvalid={error && !organisationName}
                                />
                            </Ds.Form.Control>
                            {error && !organisationName && (
                                <Ds.Form.Error>
                                    Organisation name is required.
                                </Ds.Form.Error>
                            )}
                        </Ds.Form.Field>
                        <Ds.Form.Field name="organisation-postcode">
                            <Ds.Form.Label>Organisation postcode</Ds.Form.Label>
                            <Ds.Form.Control>
                                <Ds.TextInput
                                    id="organisation-postcode"
                                    value={organisationPostcode}
                                    type="text"
                                    onChange={(e): void => {
                                        setError(false);
                                        setOrganisationPostcode(e.target.value);
                                    }}
                                    isInvalid={error && !organisationPostcode}
                                />
                            </Ds.Form.Control>
                            {error && !organisationPostcode && (
                                <Ds.Form.Error>
                                    Organisation postcode is required.
                                </Ds.Form.Error>
                            )}
                        </Ds.Form.Field>
                        <Ds.Form.Field name="organisation-ods-code">
                            <Ds.Form.Label>ODS Code (optional)</Ds.Form.Label>
                            <Ds.Form.Description>
                                If you searched by ODS code in the previous step
                                but could not find a result
                            </Ds.Form.Description>
                            <Ds.Form.Control>
                                <Ds.TextInput
                                    id="organisation-ods-code"
                                    value={organisationOdsCode}
                                    type="text"
                                    onChange={(e): void =>
                                        setOrganisationOdsCode(e.target.value)
                                    }
                                />
                            </Ds.Form.Control>
                        </Ds.Form.Field>
                    </Ds.Flex>

                    <Ds.Flex gap="2" justifyContent="space-between">
                        <Ds.Button appearance="secondary" onClick={onBackClick}>
                            Back
                        </Ds.Button>
                        <Ds.Form.Submit>Submit</Ds.Form.Submit>
                    </Ds.Flex>
                </StyledForm>
            </StyledMain>
        </StyledPageWrapper>
    );
};
